<!-- Full-screen Loader -->
<div class="global-loader-overlay" *ngIf="isLoading">
  <div class="global-spinner"></div>
</div>

<div class="auth-container">
  <!-- Left Panel: Brand, Value Prop & Trust Cards -->
  <div class="left-panel">
    <div class="brand" routerLink="/" style="cursor: pointer;">
      <img src="assets/images/beExpert.svg" alt="BeExpert Logo" class="brand-logo-img" />
      <span class="brand-text">BeExpert.ai</span>
    </div>

    <div class="hero-content">
      <h1 class="headline">
        Empower your campus.<br />Connect with opportunities.<br />With BeExpert.ai
      </h1>
      <p class="subtitle">
        Manage students, placements, assessments, and recruitment activity from one dashboard — built for colleges and universities.
      </p>

      <ul class="feature-list">
        <li>
          <span class="icon-check-wrapper">
            <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </span>
          Track every student's placement readiness in one place
        </li>
        <li>
          <span class="icon-check-wrapper">
            <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </span>
          Connect your students directly with hiring companies
        </li>
        <li>
          <span class="icon-check-wrapper">
            <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </span>
          Monitor assessments, interviews, and offers in real time
        </li>
      </ul>

      <div class="feature-cards">
        <div class="feature-card">
          <div class="icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-briefcase">
              <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </svg>
          </div>
          <div class="fc-text">
            <h4>Onboard Your College in Minutes</h4>
            <p>Set up your placement cell profile and get started</p>
          </div>
        </div>
        <div class="feature-card">
          <div class="icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-bar-chart-3">
              <path d="M3 3v18h18" />
              <path d="M18 17V9" />
              <path d="M13 17V5" />
              <path d="M8 17v-3" />
            </svg>
          </div>
          <div class="fc-text">
            <h4>Placement Insights &amp; Reports</h4>
            <p>Track student readiness and company engagement</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Panel: Auth Floating Card -->
  <div class="right-panel">
    <div class="mobile-logo-header">
      <img src="assets/images/beExpert.svg" alt="BeExpert Logo" class="mobile-logo-img" />
      <span class="brand-text">BeExpert</span>
    </div>

    <div class="auth-card">
      <ng-container *ngIf="forgotPasswordStep === 0; else forgotPasswordTemplate">
      <ng-container *ngIf="isLogin; else registerTemplate">
        <!-- ============ LOGIN ============ -->
        <div class="auth-header" *ngIf="!isVerifyingOtp">
          <h2>College Admin Sign in</h2>
          <p>Sign in with your registered email or mobile number</p>
        </div>
        <div class="auth-header" *ngIf="isVerifyingOtp">
          <h2>Verify OTP</h2>
          <p>Enter the 6-digit code we just sent</p>
        </div>

        <div class="toggle-group">
          <button class="toggle-btn" [class.active]="isLogin" type="button" (click)="toggleAuth('login')">Login</button>
          <button class="toggle-btn" [class.active]="!isLogin" type="button" (click)="toggleAuth('signup')">Register College</button>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <!-- STATE 1: Enter identifier/password (not verifying OTP) -->
          <ng-container *ngIf="!isVerifyingOtp">
            <div class="form-group" [class.has-error]="loginForm.get('identifier')?.invalid && loginForm.get('identifier')?.touched">
              <label>Email or Phone <span class="required">*</span></label>
              <input type="text" formControlName="identifier" placeholder="Registered email or phone" autocomplete="username" />
              <div class="error-message" *ngIf="loginForm.get('identifier')?.invalid && loginForm.get('identifier')?.touched">
                <span>Please enter a valid email or phone number.</span>
              </div>
            </div>

            <div class="form-group" *ngIf="loginMethod === 'password'"
                 [class.has-error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
              <label>Password <span class="required">*</span></label>
              <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
                <input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="Password"
                       style="width: 100%; padding-right: 40px;" autocomplete="current-password" />
                <button type="button" (click)="togglePasswordVisibility()" title="Toggle password visibility" class="password-toggle-btn">
                  <i [class]="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
              </div>
              <div class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                <span>Password is required.</span>
              </div>
              <div class="forgot-link-row">
                <a (click)="goToForgotPassword()">Forgot password?</a>
              </div>
            </div>

            <button type="submit" class="submit-btn" [disabled]="loginForm.invalid">
              {{ loginMethod === 'password' ? 'Sign in' : 'Send OTP' }}
            </button>

            <div class="or-divider"><span>OR</span></div>

            <button type="button" class="switch-method-btn"
                    (click)="switchLoginMethod(loginMethod === 'password' ? 'otp' : 'password')">
              Login with {{ loginMethod === 'password' ? 'OTP' : 'password' }}
            </button>
          </ng-container>

          <!-- STATE 2: Verify OTP -->
          <ng-container *ngIf="isVerifyingOtp">
            <div class="form-group" [class.has-error]="loginForm.get('otp')?.invalid && loginForm.get('otp')?.touched">
              <label>Enter 6-digit OTP</label>
              <p class="otp-hint-text">Sent to <span class="highlight">{{ otpTarget }}</span></p>
              <input type="text" formControlName="otp" placeholder="enter 6-digit otp" maxlength="6" autocomplete="one-time-code" />
              <div class="error-message" *ngIf="loginForm.get('otp')?.invalid && loginForm.get('otp')?.touched">
                <span *ngIf="loginForm.get('otp')?.errors?.['required']">OTP is required.</span>
                <span *ngIf="loginForm.get('otp')?.errors?.['pattern']">OTP must be exactly 6 digits.</span>
              </div>
            </div>

            <button type="submit" class="submit-btn" [disabled]="loginForm.get('otp')?.invalid">
              Verify &amp; Sign in
            </button>

            <div class="change-target-wrapper">
              <button type="button" class="change-target-btn" (click)="resendOtp()">Resend OTP</button>
              <button type="button" class="change-target-btn" (click)="changeOtpTarget()">&larr; Change email/number</button>
            </div>
          </ng-container>
        </form>

        <div class="footer-link">
          <p>New here? <a (click)="toggleAuth('signup')">Register your college</a></p>
        </div>
      </ng-container>

      <ng-template #registerTemplate>
        <!-- ============ REGISTER ============ -->
        <div class="auth-header">
          <h2>Register Your College</h2>
          <p>Tell us about your institution to get started</p>
        </div>

        <div class="toggle-group">
          <button class="toggle-btn" [class.active]="isLogin" type="button" (click)="toggleAuth('login')">Login</button>
          <button class="toggle-btn" [class.active]="!isLogin" type="button" (click)="toggleAuth('signup')">Register College</button>
        </div>

        <ng-container *ngIf="!isVerifyingRegistrationOtp">
        <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
          <div class="form-group"
               [class.has-error]="registerForm.get('college_name')?.invalid && registerForm.get('college_name')?.touched">
            <label>College / University Name <span class="required">*</span></label>
            <app-college-autocomplete class="college-auth-ac" [control]="collegeNameControl" [minSearchLength]="3"
              (collegeSelected)="selectInstitution($event)" (selectionCleared)="onCollegeSelectionCleared()"
              (cantFind)="onCantFindCollege()">
              <input type="text" placeholder="Search your college/university..."
                     formControlName="college_name" autocomplete="off" />
              <div class="error-message" *ngIf="registerForm.get('college_name')?.invalid && registerForm.get('college_name')?.touched">
                <span>College name is required.</span>
              </div>
              <div class="error-message" *ngIf="registerForm.get('college_name')?.valid && !selectedInstitutionId &&
                       registerForm.get('college_name')?.touched">
                <span>Please select your college from the list, or use "Can't find your college/university?" to add it.</span>
              </div>
            </app-college-autocomplete>
          </div>

          <div class="form-group" [class.has-error]="registerForm.get('college_url')?.invalid && registerForm.get('college_url')?.touched">
            <label>College Website URL <span class="required">*</span></label>
            <input type="text" placeholder="https://yourcollege.edu" formControlName="college_url" />
            <div class="error-message" *ngIf="registerForm.get('college_url')?.invalid && registerForm.get('college_url')?.touched">
              <span>Please enter a valid URL.</span>
            </div>
          </div>

          <div class="form-group">
            <label>Affiliated University</label>
            <input type="text" placeholder="Affiliated university (optional)" formControlName="university_name" />
          </div>

          <div class="form-group">
            <label>Ranking</label>
            <input type="text" placeholder="e.g. NIRF 150-200 (optional)" formControlName="ranking" />
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>City</label>
              <input type="text" placeholder="City" formControlName="city" />
            </div>
            <div class="form-group">
              <label>State</label>
              <input type="text" placeholder="State" formControlName="state" />
            </div>
          </div>

          <div class="form-group">
            <label>Country</label>
            <input type="text" formControlName="country" readonly />
          </div>

          <!-- Streams multi-select -->
          <div class="form-group" style="position: relative;">
            <label>Streams <span class="required">*</span></label>
            <input type="text" placeholder="Search streams e.g. BCA, B.Com, BE..."
                   (input)="onStreamInput($event)" (blur)="showStreamsDropdown = false"
                   #streamInput (keydown.enter)="$event.preventDefault(); addStream(streamInput.value); streamInput.value=''" />
            <div class="chip-dropdown" *ngIf="showStreamsDropdown">
              <div class="chip-option" *ngFor="let s of filteredStreams" (mousedown)="addStream(s); streamInput.value=''">{{ s }}</div>
            </div>
            <div class="chip-list">
              <span class="chip" *ngFor="let s of streams; let i = index">
                {{ s }} <i class="bi bi-x" (click)="removeStream(i)"></i>
              </span>
            </div>
          </div>

          <!-- Courses offered multi-select -->
          <div class="form-group" style="position: relative;">
            <label>Courses Offered</label>
            <input type="text" placeholder="Search branches e.g. Computer Science, Mechanical..."
                   (input)="onBranchInput($event)" (blur)="showBranchesDropdown = false"
                   #branchInput (keydown.enter)="$event.preventDefault(); addBranch(branchInput.value); branchInput.value=''" />
            <div class="chip-dropdown" *ngIf="showBranchesDropdown">
              <div class="chip-option" *ngFor="let c of filteredBranches" (mousedown)="addBranch(c); branchInput.value=''">{{ c }}</div>
            </div>
            <div class="chip-list">
              <span class="chip" *ngFor="let c of coursesOffered; let i = index">
                {{ c }} <i class="bi bi-x" (click)="removeBranch(i)"></i>
              </span>
            </div>
          </div>

          <!-- Placement industries multi-select -->
          <div class="form-group" style="position: relative;">
            <label>Placement Industries <span class="required">*</span></label>
            <input type="text" placeholder="Search industries e.g. IT, Finance..."
                   (input)="onIndustryInput($event)" (blur)="showIndustriesDropdown = false"
                   #industryInput (keydown.enter)="$event.preventDefault(); addIndustry(industryInput.value); industryInput.value=''" />
            <div class="chip-dropdown" *ngIf="showIndustriesDropdown">
              <div class="chip-option" *ngFor="let ind of filteredIndustries" (mousedown)="addIndustry(ind); industryInput.value=''">{{ ind }}</div>
            </div>
            <div class="chip-list">
              <span class="chip" *ngFor="let ind of placementIndustries; let i = index">
                {{ ind }} <i class="bi bi-x" (click)="removeIndustry(i)"></i>
              </span>
            </div>
          </div>

          <!-- Logo upload -->
          <div class="form-group">
            <label>College Logo</label>
            <div class="logo-upload">
              <label class="logo-upload-box" *ngIf="!logoPreview">
                <input type="file" accept="image/png,image/jpeg,image/jpg,image/svg+xml,image/webp" (change)="onLogoSelect($event)" hidden />
                <i class="bi bi-cloud-upload"></i>
                <span>Upload logo (PNG/JPG/SVG/WebP, max 2MB)</span>
              </label>
              <div class="logo-preview" *ngIf="logoPreview">
                <img [src]="logoPreview" alt="Logo preview" />
                <button type="button" class="remove-logo-btn" (click)="removeLogo($event)"><i class="bi bi-x-lg"></i></button>
              </div>
            </div>
          </div>

          <div class="section-divider">Point of Contact</div>

          <div class="form-group" [class.has-error]="registerForm.get('point_of_contact_name')?.invalid && registerForm.get('point_of_contact_name')?.touched">
            <label>Contact Name <span class="required">*</span></label>
            <input type="text" placeholder="Point of contact name" formControlName="point_of_contact_name" autocomplete="name" />
            <div class="error-message" *ngIf="registerForm.get('point_of_contact_name')?.invalid && registerForm.get('point_of_contact_name')?.touched">
              <span>Contact name is required.</span>
            </div>
          </div>

          <div class="form-group" [class.has-error]="registerForm.get('point_of_contact_email')?.invalid && registerForm.get('point_of_contact_email')?.touched">
            <label>Contact Email <span class="required">*</span></label>
            <input type="email" placeholder="Point of contact email" formControlName="point_of_contact_email" autocomplete="email" />
            <div class="error-message" *ngIf="registerForm.get('point_of_contact_email')?.invalid && registerForm.get('point_of_contact_email')?.touched">
              <span>Please enter a valid email address.</span>
            </div>
          </div>

          <div class="form-group" [class.has-error]="registerForm.get('phone_number')?.invalid && registerForm.get('phone_number')?.touched">
            <label>Phone Number <span class="required">*</span></label>
            <input type="tel" placeholder="10-digit mobile number" formControlName="phone_number"
                   maxlength="10" inputmode="numeric" (input)="onPhoneInput($event)" />
            <div class="error-message" *ngIf="registerForm.get('phone_number')?.invalid && registerForm.get('phone_number')?.touched">
              <span>Please enter a valid phone number.</span>
            </div>
          </div>

          <div class="form-group" [class.has-error]="registerForm.get('password')?.invalid && registerForm.get('password')?.touched">
            <label>Password <span class="required">*</span></label>
            <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
              <input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="Create a password"
                     style="width: 100%; padding-right: 40px;" />
              <button type="button" (click)="togglePasswordVisibility()" title="Toggle password visibility" class="password-toggle-btn">
                <i [class]="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </button>
            </div>
            <div class="error-message" *ngIf="registerForm.get('password')?.invalid && registerForm.get('password')?.touched">
              <span>Password must be 8-32 characters with upper/lowercase, a number and a special character.</span>
            </div>
          </div>

          <div class="form-group" [class.has-error]="registerForm.hasError('passwordMismatch') && registerForm.get('confirm_password')?.touched">
            <label>Confirm Password <span class="required">*</span></label>
            <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
              <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirm_password" placeholder="Confirm password"
                     style="width: 100%; padding-right: 40px;" />
              <button type="button" (click)="toggleConfirmPasswordVisibility()" title="Toggle confirm password visibility" class="password-toggle-btn">
                <i [class]="showConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </button>
            </div>
            <div class="error-message" *ngIf="registerForm.hasError('passwordMismatch') && registerForm.get('confirm_password')?.touched">
              <span>Passwords do not match.</span>
            </div>
          </div>

          <div class="info-alert">
            <svg class="alert-shield" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
            <p>
              We'll send a verification OTP to your point-of-contact email
              before you can continue.
            </p>
          </div>

          <button type="submit" class="submit-btn" [disabled]="isLoading || !selectedInstitutionId">
            <span *ngIf="!isLoading">Send Verification OTP</span>
            <span *ngIf="isLoading">Sending…</span>
          </button>
        </form>
        </ng-container>

        <ng-container *ngIf="isVerifyingRegistrationOtp">
          <div class="form-group" [class.has-error]="registrationOtpControl.touched && registrationOtpControl.invalid">
            <label>Enter 6-digit OTP</label>
            <p class="otp-hint-text">
              Sent to <span class="highlight">{{ registrationOtpTarget }}</span>
            </p>
            <input type="text" [formControl]="registrationOtpControl" placeholder="enter 6-digit otp" maxlength="6"
              autocomplete="one-time-code" />
            <div class="error-message" *ngIf="registrationOtpControl.touched && registrationOtpControl.invalid">
              <span *ngIf="registrationOtpControl.errors?.['required']">OTP is required.</span>
              <span *ngIf="registrationOtpControl.errors?.['pattern']">OTP must be exactly 6 digits.</span>
              <span *ngIf="registrationOtpControl.errors?.['incorrect']">Invalid OTP. Please try again.</span>
            </div>
          </div>

          <button type="button" class="submit-btn" [disabled]="isLoading || registrationOtpControl.invalid" (click)="verifyRegistrationOtp()">
            <span *ngIf="!isLoading">Verify &amp; Register</span>
            <span *ngIf="isLoading">Verifying…</span>
          </button>

          <div class="change-target-wrapper" style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px;">
            <button type="button" class="change-target-btn" (click)="resendRegistrationOtp()">Resend OTP</button>
            <button type="button" class="change-target-btn" (click)="changeRegistrationOtpTarget()">&larr; Edit details</button>
          </div>
        </ng-container>

        <div class="footer-link">
          <p>Already have an account? <a (click)="toggleAuth('login')">Sign in</a></p>
        </div>
      </ng-template>
      </ng-container>

      <ng-template #forgotPasswordTemplate>
        <!-- ============ FORGOT PASSWORD ============ -->
        <div class="auth-header" *ngIf="forgotPasswordStep !== 4">
          <h2>Reset Password</h2>
          <p>Recover access to your college admin account</p>
        </div>

        <div class="fp-back-row" *ngIf="forgotPasswordStep < 4">
          <a class="fp-back-link" (click)="forgotPasswordBack()">
            <i class="bi bi-arrow-left"></i>
            <span>Back</span>
          </a>
        </div>

        <!-- STEP 1: ACCOUNT -->
        <ng-container *ngIf="forgotPasswordStep === 1">
          <p class="fp-step-hint">Enter your registered email and we'll send you a code to reset your password.</p>

          <form [formGroup]="forgotPasswordAccountForm" (ngSubmit)="submitForgotPasswordAccount()">
            <div class="form-group"
                 [class.has-error]="forgotPasswordAccountForm.get('identifier')?.invalid && forgotPasswordAccountForm.get('identifier')?.touched">
              <label>Registered Email</label>
              <input type="text" formControlName="identifier" placeholder="you@college.edu" />
              <div class="error-message"
                   *ngIf="forgotPasswordAccountForm.get('identifier')?.invalid && forgotPasswordAccountForm.get('identifier')?.touched">
                <span *ngIf="forgotPasswordAccountForm.get('identifier')?.errors?.['required']">Email is required.</span>
                <span *ngIf="forgotPasswordAccountForm.get('identifier')?.errors?.['email']">Enter a valid email address.</span>
              </div>
            </div>

            <button type="submit" class="submit-btn" [disabled]="forgotPasswordAccountForm.invalid || isLoading">
              Send reset code
            </button>
          </form>
        </ng-container>

        <!-- STEP 2: VERIFY -->
        <ng-container *ngIf="forgotPasswordStep === 2">
          <p class="fp-step-hint">Enter the 6-digit code we sent to your email</p>
          <p class="fp-target">{{ forgotPasswordEmailOrPhone }}</p>

          <form (submit)="submitForgotPasswordVerify(); $event.preventDefault()">
            <div class="form-group">
              <div class="fp-otp-inputs" (paste)="handleFpOtpPaste($event)">
                <input *ngFor="let v of forgotPasswordOtpValues; let i = index; trackBy: trackByIndex"
                       [id]="'college-fp-otp-input-' + i" type="text" maxlength="1" inputmode="numeric"
                       autocomplete="one-time-code" class="fp-otp-box"
                       [value]="forgotPasswordOtpValues[i]" (input)="handleFpOtpInput($event, i)"
                       (keydown)="handleFpKeyDown($event, i)" />
              </div>
            </div>

            <button type="submit" class="submit-btn" [disabled]="!isFpOtpFilled() || isLoading">Verify code</button>
          </form>

          <div class="fp-resend-row">
            <span>Didn't get the code? </span>
            <button type="button" class="fp-resend-btn" (click)="resendFpOtp()" [disabled]="resendCountdown > 0 || isResendingOtp">
              <ng-container *ngIf="isResendingOtp">Resending...</ng-container>
              <ng-container *ngIf="!isResendingOtp && resendCountdown > 0">Resend in {{ resendCountdown }}s</ng-container>
              <ng-container *ngIf="!isResendingOtp && resendCountdown === 0">Resend OTP</ng-container>
            </button>
          </div>
        </ng-container>

        <!-- STEP 3: RESET PASSWORD -->
        <ng-container *ngIf="forgotPasswordStep === 3">
          <p class="fp-step-hint">Create a new password for</p>
          <p class="fp-target">{{ forgotPasswordEmailOrPhone }}</p>

          <form [formGroup]="forgotPasswordResetForm" (ngSubmit)="submitForgotPasswordReset()">
            <div class="form-group"
                 [class.has-error]="forgotPasswordResetForm.get('password')?.invalid && forgotPasswordResetForm.get('password')?.touched">
              <label>New Password</label>
              <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
                <input [type]="showFpPassword ? 'text' : 'password'" formControlName="password" placeholder="Enter new password"
                       style="width: 100%; padding-right: 40px;" />
                <button type="button" (click)="showFpPassword = !showFpPassword" title="Toggle password visibility" class="password-toggle-btn">
                  <i [class]="showFpPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
              </div>
              <div class="error-message"
                   *ngIf="forgotPasswordResetForm.get('password')?.invalid && (forgotPasswordResetForm.get('password')?.touched || forgotPasswordResetForm.get('password')?.dirty)">
                <span *ngIf="forgotPasswordResetForm.get('password')?.errors?.['required']">Password is required.</span>
                <span *ngIf="forgotPasswordResetForm.get('password')?.errors?.['minlength']">Minimum 8 characters required.</span>
                <span *ngIf="forgotPasswordResetForm.get('password')?.errors?.['passwordStrength'] && !forgotPasswordResetForm.get('password')?.errors?.['minlength']">
                  Password must contain uppercase, lowercase, numbers, and special characters.
                </span>
              </div>
            </div>

            <div class="form-group"
                 [class.has-error]="(forgotPasswordResetForm.get('confirm_password')?.invalid && forgotPasswordResetForm.get('confirm_password')?.touched) ||
                                     (forgotPasswordResetForm.hasError('passwordMismatch') && forgotPasswordResetForm.get('confirm_password')?.touched)">
              <label>Confirm New Password</label>
              <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
                <input [type]="showFpConfirmPassword ? 'text' : 'password'" formControlName="confirm_password" placeholder="Re-enter new password"
                       style="width: 100%; padding-right: 40px;" />
                <button type="button" (click)="showFpConfirmPassword = !showFpConfirmPassword" title="Toggle confirm password visibility" class="password-toggle-btn">
                  <i [class]="showFpConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
              </div>
              <div class="error-message" *ngIf="forgotPasswordResetForm.get('confirm_password')?.touched">
                <span *ngIf="forgotPasswordResetForm.get('confirm_password')?.errors?.['required']">Please confirm your password.</span>
                <span *ngIf="!forgotPasswordResetForm.get('confirm_password')?.errors?.['required'] && forgotPasswordResetForm.hasError('passwordMismatch')">Passwords do not match.</span>
              </div>
            </div>

            <button type="submit" class="submit-btn" [disabled]="forgotPasswordResetForm.invalid || isLoading">Reset password</button>
          </form>
        </ng-container>

        <!-- STEP 4: SUCCESS -->
        <ng-container *ngIf="forgotPasswordStep === 4">
          <div class="fp-success">
            <div class="fp-success-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h2>Password updated</h2>
            <p>Your password has been reset successfully.</p>
            <button class="submit-btn" type="button" (click)="forgotPasswordStep = 0">Back to login</button>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
</div>
